import { render, staticRenderFns } from "./RouteVehicleDriverSummary.vue?vue&type=template&id=56120e84&scoped=true&"
import script from "./RouteVehicleDriverSummary.vue?vue&type=script&lang=js&"
export * from "./RouteVehicleDriverSummary.vue?vue&type=script&lang=js&"
import style0 from "./RouteVehicleDriverSummary.vue?vue&type=style&index=0&id=56120e84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56120e84",
  null
  
)

export default component.exports